import TicketToolbar from './TicketToolbar';
import ThreadToolbar from './ThreadToolbar';
import { getUserPermissions } from '../../tickets/operators/ticketGetters';
import { getIsUngatedForLimitedTicketFunctionality } from '../../selectors/gateSelectors';
import { useSelector } from 'react-redux';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const ToolbarContainer = ({
  ticket,
  inboxId,
  threadId
}) => {
  const currentUserCanView = ticket ? getUserPermissions(ticket).currentUserCanView : false;
  const hasAssociatedTickets = !!ticket;
  const shouldLimitTicketFunctionality = useSelector(getIsUngatedForLimitedTicketFunctionality);
  const shouldRenderThreadToolbar = !hasAssociatedTickets || !currentUserCanView;
  return /*#__PURE__*/_jsx(View, {
    borderBlockEndWidth: "100",
    borderBlockEndStyle: "solid",
    borderBlockEndColor: "border-core-subtle",
    backgroundColor: "fill-surface-default",
    paddingInlineEnd: "600",
    paddingInlineStart: "600",
    paddingBlockEnd: "200",
    paddingBlockStart: "200",
    children: /*#__PURE__*/_jsx(View, {
      marginBlockEnd: "0",
      "data-test-id": "sticky-subject-header",
      children: shouldRenderThreadToolbar || shouldLimitTicketFunctionality ? /*#__PURE__*/_jsx(ThreadToolbar, {
        threadId: threadId,
        inboxId: inboxId
      }) : /*#__PURE__*/_jsx(TicketToolbar, {
        ticket: ticket,
        threadId: threadId,
        inboxId: inboxId
      })
    })
  });
};
ToolbarContainer.displayName = 'TicketHeaderToolbar';
export default ToolbarContainer;